import type { ReactNode } from 'react';

import { UnknownErrorPage } from '../../../../../../../shared/application/pages/UnknownErrorPage/UnknownErrorPage';
import { AppErrorBoundary, ErrorBoundaryLevel } from '../AppErrorBoundary';

export const NonCriticErrorBoundary = ({ children }: { children: ReactNode }) => {
  return (
    <AppErrorBoundary
      level={ErrorBoundaryLevel.NON_CRITICAL}
      errorComponent={<UnknownErrorPage />}
    >
      {children}
    </AppErrorBoundary>
  );
};
